<div class="embed-container" provide-parent-form>
	<embed-preview *ngIf="mediaclip" class="contents" [mediaclip]="mediaclip"
		[configuration]="{standAlone: true, autoPlay: false, alwaysShow: false, showVideo: false}" [isActive]="'true'"
		[form]="form" name="embed-preview" (onPlayoutChange)="onPlayoutChanged($event)">

		<div class="custom-warning">
			<span *ngIf="mediaclip?.status === 'draft'" class="message warning ng-binding">
				<i class="fa"></i>&nbsp;{{ 'HELP.MEDIACLIP_NOT_PUBLISHED' | translate }}.
			</span>
		</div>

	</embed-preview>
</div>
